import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  phoneNumber: string | null;
  upiId: string | null;
  isAuthenticated: boolean;
  visitorId: string | null;
  adSource: string | null;
}

const initialState: UserState = {
  phoneNumber: null,
  upiId: null,
  isAuthenticated: false,
  visitorId: null,
  adSource: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload;
    },
    setUpiId: (state, action: PayloadAction<string>) => {
      state.upiId = action.payload;
    },
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setVisitorId: (state, action: PayloadAction<string>) => {
      state.visitorId = action.payload;
    },
    setAdSource: (state, action: PayloadAction<string>) => {
      state.adSource = action.payload;
    },
    logout: (state) => {
      state.phoneNumber = null;
      state.upiId = null;
      state.isAuthenticated = false;
    },
  },
});

export const {
  setPhoneNumber,
  setUpiId,
  setAuthenticated,
  setVisitorId,
  setAdSource,
  logout,
} = userSlice.actions;

export default userSlice.reducer;
